import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTileComponent } from './simple-icons-tile.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTileComponent ],
    exports:      [ SimpleIconsTileComponent ],
    bootstrap:    []
})
export class SimpleIconsTileModule {}
